<template>
 <header id="dhead">
   <div class="head">
     <div class="lf msg">
      <h1 class="lf">
        <a :href="url">
          <img src="../assets/image/logo.png" alt="企业福利助手"/>
        </a>
      </h1>
      <nav class="lf nav">
        <router-link to="/home">首页</router-link>
        <router-link to="/programme">福利方案</router-link>
        <router-link to="/about">关于我们</router-link>
      </nav>
     </div>
    <div class="rt btn">
      <div class="rt login"><a target="_blank" :href="url+'benefit/login'">企业登录</a></div>
      <div class="rt test"><a target="_blank" href="https://life.daishujiankang.com/benefit/login?trial=1">立即体验</a></div>
      <div class="rt tel">4001-0755-70 转6</div>
    </div>
   </div>
 </header>
</template>
<script>
export default {
  name: 'DHead',
  data() {
    return {
      url: this.baseUrl
    }
  }
}
</script>
<style scoped lang="less">
#dhead {
  height: 95px;
  width: 100%;
  box-shadow:0px 2px 8px 0px rgba(0,0,0,0.1);
  .head {
    padding-top: 26px;
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    overflow: hidden;
    .msg {
      overflow: hidden;
      h1 {
        a {
          img {
            width: 164px;
            height: 45px;
          }
        }
      }
      .nav {
        margin-top: 8px;
        a {
          font-size:16px;
          font-family: @PingFangSC-Regular;
          font-weight:400;
          color:@text-color;
          line-height:22px;
          margin-left: 50px;
          padding-bottom: 5px;
          &:hover, &.router-link-exact-active, &.router-link-active {
            color: @main-color;
            border-bottom: 2px solid @theme-color;
          }
        }
      }
    }
    .btn {
      overflow: hidden;
      &>div {
        font-size:16px;
      }
      .tel {
        padding-left: 34px;
        background: url('@{image}tel.png') no-repeat left center / 26px 26px;
      }
      .tel {
        margin-left: 40px;
        font-family: @PingFangSC-Regular;
        font-weight:400;
        color: @text-color;
        line-height:38px;
      }
      .test {
        margin-left: 40px;
        width:120px;
        height:38px;
        border-radius:19px;
        border:1px solid @main-color;
        text-align: center;
        a {
          display: inline-block;
          height: 100%;
          width: 100%;
          font-family: @PingFangSC-Semibold;
          font-weight:600;
          color:@main-color;
          line-height:38px;
        }
      }
      .login {
        margin: 0px 50px;
        a {
          display: inline-block;
          height: 100%;
          width: 100%;
          color:@text-color;
          font-size:16px;
          font-family: @PingFangSC-Regular;
          font-weight:400;
          line-height:40px;
        }
      }
      .login,.test {
        cursor: pointer;
      }
    }
  }
}
</style>
